import Skeleton from '@material-ui/lab/Skeleton';
import type { FC } from 'react';

export const PackagePopoutSkeleton: FC = () => (
  <>
    <Skeleton variant="rect" width={285} height={180} style={{ marginLeft: '16px', marginRight: '16px' }} />
    <Skeleton variant="rect" width={285} height={180} style={{ marginLeft: '16px', marginRight: '16px' }} />
    <Skeleton variant="rect" width={285} height={180} style={{ marginLeft: '16px', marginRight: '16px' }} />
    <Skeleton variant="rect" width={285} height={180} style={{ marginLeft: '16px', marginRight: '16px' }} />
    <Skeleton variant="rect" width={285} height={180} style={{ marginLeft: '16px', marginRight: '16px' }} />
  </>
);
